import { render } from "./offer-approvals.vue?vue&type=template&id=72ab80a4"
import script from "./offer-approvals.vue?vue&type=script&lang=js"
export * from "./offer-approvals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__